import { createReducer } from "@reduxjs/toolkit";
import { IDiagramSettingsState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";
import { DIAGRAM_SETTINGS_DEFAULT } from "../../models/diagram";

const initialState = {
  data: DIAGRAM_SETTINGS_DEFAULT,
  state: StoreState.None,
} as IDiagramSettingsState;

export const diagramSettingsReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.diagramSettingsFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.diagramSettingsFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.diagramSettingsFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
